import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, elements } from 'chart.js';
import { useNavigate} from 'react-router-dom';
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";

ChartJS.register(ArcElement, Tooltip, Legend);

function Results(){
    let data = {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
                'rgba(218, 34, 45, 0.8)',
                'rgba(54, 162, 235, 0.8)',
              'rgba(135, 162, 0, 0.8)',
            ],
            borderWidth: 1,
          },
        ],
    };
    const category = [
        {
            'cateogory': '家電',
            'order': 1
        },{
            'category': '美容・健康',
            'order': 2
        },{
            'category': '体験 (旅行・テーマパークなど)',
            'order': 3
        },{
            'category': 'グルメ',
            'order': 4
        }
    ]
    const items = [
        {
                    'option': 'AirPods',
                    'src': '../img/AirPods.jpg',
                    'order': 1,
                    'label': 'AirPods Pro3'
                }, {
                    'option': 'Sharp',
                    'src': '../img/Sharp.jpg',
                    'order': 2,
                    'label': 'SHARP 加湿空気清浄機'
                }, {
                    'option': 'Echo',
                    'src': '../img/Echo.jpg',
                    'order': 3,
                    'label': '(スマートホームセット) Amazon Echo Dot + NatureRemo3'
                }, {
                    'option': 'Bruno',
                    'src': '../img/Bruno.png',
                    'order': 4,
                    'label': 'BRUNO ホットプレート'
                }, {
                    'option': 'Terra',
                    'src': '../img/Terra.jpg',
                    'order': 5,
                    'label': 'ソーダストリーム TERRA'
        },
        {
                    'option': 'Lamdash',
                    'src': '../img/Lamdash.jpg',
                    'order': 6,
                    'label': 'Panasonic ラムダッシュパームイン'
                }, {
                    'option': 'Kassa',
                    'src': '../img/Kassa.jpg',
                    'order': 7,
                    'label': 'Panasonic リフトケア美顔器 バイタリフト かっさ'
                }, {
                    'option': 'Mytrex',
                    'src': '../img/Mytrex.jpg',
                    'order': 8,
                    'label': 'MYTREX ヒートネック'
                }, {
                    'option': 'Shiro',
                    'src': '../img/Shiro.jpg',
                    'order': 9,
                    'label': 'SHIRO ルームフレグランス'
                }, {
                    'option': 'Aesop',
                    'src': '../img/Aesop.jpg',
                    'order': 10,
                    'label': 'Aesop アロマティック ハンドウォッシュ'
        },
        {
                    'option': 'Experience',
                    'src': '../img/Experience.jpg',
                    'order': 11,
                    'label': '体験型Gift Premium ペア'
                }, {
                    'option': 'Disney',
                    'src': '../img/disney.jpg',
                    'order': 12,
                    'label': 'ディズニーチケット ペア'
                }, {
                    'option': 'Tea',
                    'src': '../img/Tea.jpg',
                    'order': 13,
                    'label': '高級ホテルアフタヌーンティ ペア'
                }, {
                    'option': 'Hiruton',
                    'src': '../img/Hiruton.jpg',
                    'order': 14,
                    'label': 'ヒルトン東京日本料理食事券 ペア'
                }, {
                    'option': 'Spa',
                    'src': '../img/Spa.jpg',
                    'order': 15,
                    'label': 'Times Spa Resta 利用券 ペア'
                }, {
                    'option': 'Sauna',
                    'src': '../img/Sauna.jpg',
                    'order': 16,
                    'label': 'サウナスパ利用券 1~2名'
                }, {
                    'option': 'Cafe',
                    'src': '../img/Cafe.jpg',
                    'order': 17,
                    'label': 'カフェ利用券'
        },
        {
                    'option': 'Matsuzaka',
                    'src': '../img/Matsuzaka.jpg',
                    'order': 18,
                    'label': '松坂牛 サーロインステーキ 200g×2'
                }, {
                    'option': 'Crab',
                    'src': '../img/Crab.jpg',
                    'order': 19,
                    'label': '北海道産 ボイル毛ガニ 2尾'
                }, {
                    'option': 'Conger',
                    'src': '../img/Conger.jpg',
                    'order': 20,
                    'label': '淡路島 焼きアナゴ 5本セット'
                }, {
                    'option': 'Sukiyaki',
                    'src': '../img/Sukiyaki.jpg',
                    'order': 21,
                    'label': '三田和牛 肩ロース すき焼き 300g'
                }, {
                    'option': 'Shabu',
                    'src': '../img/Shabu.jpg',
                    'order': 22,
                    'label': '平田牧場 三元豚しゃぶしゃぶ'
                }, {
                    'option': 'Kobe',
                    'src': '../img/Kobe.jpg',
                    'order': 23,
                    'label': '神戸牛 すき焼き用 モモ肉 250g'
                }, {
                    'option': 'Sensuke',
                    'src': '../img/Sensuke.jpg',
                    'order': 24,
                    'label': '日本酒 仙介 純米大吟醸 720ml'
                }, {
                    'option': 'Rice',
                    'src': '../img/Rice.jpg',
                    'order': 25,
                    'label': '長岡産 コシヒカリ 5kg'
                }, {
                    'option': 'Melon',
                    'src': '../img/Melon.jpg',
                    'order': 26,
                    'label': '静岡県産 クラウンマスクメロン'
                }, {
                    'option': 'Oyster',
                    'src': '../img/Oyster.jpg',
                    'order': 27,
                    'label': '広島県産 大粒カキフライ 20個'
                }, {
                    'option': 'Ice',
                    'src': '../img/Ice.jpg',
                    'order': 28,
                    'label': '銀座千疋屋 ミルフィーユアイス'
                }, {
                    'option': 'Kaisen',
                    'src': '../img/Kaisen.jpg',
                    'order': 29,
                    'label': '能登半島 北陸海鮮漬け丼の具 6食'
                }, {
                    'option': 'Steak',
                    'src': '../img/Steak.jpg',
                    'order': 30,
                    'label': '神戸洋食 デミグラスハンバーグ 9個'
                }, {
                    'option': 'Chinese',
                    'src': '../img/Chinese.jpg',
                    'order': 31,
                    'label': '赤坂四川飯店監修 中華料理セット'
                }, {
                    'option': 'Financier',
                    'src': '../img/Financier.jpg',
                    'order': 32,
                    'label': 'シェフ・アサヤマ フィナンシェ 12個'
                }, {
                    'option': 'Ramen',
                    'src': '../img/Ramen.jpg',
                    'order': 33,
                    'label': '喜多方ラーメン 12食'
                }, {
                    'option': 'Cake',
                    'src': '../img/Cake.jpg',
                    'order': 34,
                    'label': 'ホシフルーツ 大人のチーズケーキ'
        }
    ]

    const [categoryPieData, setCategoryPieData] = useState(data);
    const [optionPieData, setOptionPieData] = useState(data);
    const [chartCategory, setChartCategory] = useState({
        plugins: {
            //タイトル関連
            legend: {
              labels: {
                color: "#fff",
                font: {
                  size: 12,
                },
              },
            },
          }
    });
    const [chartOptions, setChartOptions] = useState({
        plugins: {
            //タイトル関連
            legend: {
                display: true,
                position: 'top',
                labels: {
                    color: "#fff",
                    font: {
                    size: 12,
                    },
                },
            },
          }
    });
    const [isFetch, setIsFetch] = useState(false);
    const [stateRenderCategory, setStateRenderCategory] = useState("");
    // const [voteResult, setVoteResult] = useState(null);
    const [form, setForm] = useState(null);
    const [votedCategory, setVotedCategory] = useState("");
    const [votedOption, setVotedOption] = useState("");
    const [open, setOpen] = useState(false);
    const [stateFetchedData, setStateFetchedData] = useState(null);
    const chartRef = useRef();
    const navigate = useNavigate();

    let pingInterval;
    let fetchedData = null;
    let renderCategory = null;
    useEffect(() => {
        setIsFetch(true);
        const fetchVotes = async () => {
            const response
                = await axios.post('https://4m8qo3vqvl.execute-api.us-east-1.amazonaws.com/Product', {
                    'call': 'GET /count/{option}'
            });
            fetchedData = response.data.body;
            setStateFetchedData(fetchedData);
            renderPieChart();
        };
        socketFunc(fetchVotes);
        const storageForm = localStorage.getItem('form');
        if(!storageForm){
            setForm(JSON.parse(storageForm));
        }        const value = items.filter(x => x.option == localStorage.getItem('option'));
        if(value.length){
            setVotedCategory(localStorage.getItem('category'));
            setVotedOption(value[0].label);
        }

    }, []);

    const renderPieChart = () => {
        const categoryObject = fetchedData.reduce((acc, item) => {
            acc[item.category] = (acc[item.category] || 0) + item.count;
            return acc;
        }, {});
        let tempCategoryArray = Object.entries(categoryObject).map(([key, value]) => ({ key, value }));
        tempCategoryArray.forEach(item => {
            item.order = category.filter(x => x.category === item.key)[0]?.order
        });
        tempCategoryArray = tempCategoryArray.filter(x => x.value > 0).sort((a, b) => a.order > b.order ? 1 : -1);
        const categoryPie = {
            labels: tempCategoryArray.map(x => x.key),
            datasets: [
              {
                data: tempCategoryArray.map(x => x.value),
                backgroundColor: [
                    'rgba(218, 34, 45, 0.8)',
                    'rgba(54, 162, 235, 0.8)',
                    'rgba(135, 162, 0, 0.8)',
                    'rgba(162, 0, 162, 0.8)',
                ],
                borderWidth: 1,
              },
            ],
        };
        setCategoryPieData(categoryPie);
        renderOption();
        setIsFetch(false);
    }

    const socketFunc = (openCallback) => {
        const socket = new WebSocket('wss://fxu9alub62.execute-api.us-east-1.amazonaws.com/production/');
        socket.onopen = e => {
            openCallback();
            pingInterval = setInterval(() => {
                socket.send('ping');
            }, 300000);
        }
        socket.onmessage = e => {
            const message = JSON.parse(e.data);
            let alreadyData = fetchedData.filter(x => x.option === message.option)[0];
            if(alreadyData){
                alreadyData = message;
            }else{
                fetchedData.push(message);
            }
            setStateFetchedData(fetchedData);
            renderPieChart();
        }
        socket.onclose = e => {
            clearInterval(pingInterval);
        }
    }

    const selectCategory = (event) => {
        const chart = chartRef.current;
        if(!chart) { return; }
        const elements = chart.getElementsAtEventForMode(
            event,
            "nearest", // 最近傍の要素を取得
            { intersect: true },
            true
        );
        if(!elements) { return; }
        if(!elements[0]) { return; }
        renderCategory = categoryPieData.labels[elements[0].index];
        setStateRenderCategory(renderCategory);
        setOpen(true);
        renderOption();
    }

    const renderOption = () => {
        if(!renderCategory) {
            renderCategory = stateRenderCategory;
        }
        if(renderCategory){
            if(!fetchedData){
                fetchedData = stateFetchedData;
            }
            let filteredItem = fetchedData.filter(x => x.category === renderCategory);
            filteredItem.forEach(x => {
                const selected = items.filter(y => y.option === x.option)[0];
                if(!selected){ return; }
                x.order = selected.order;
                x.label = selected.label;
            });
            filteredItem = filteredItem.filter(x => x.count > 0).sort((a, b) => a.order > b.order ? 1 : -1);
            const optionPie = {
                labels: filteredItem.map(x => x.label),
                datasets: [
                  {
                    data: filteredItem.map(x => x.count),
                    backgroundColor: [
                        'rgba(255, 179, 186, 0.8)',
                        'rgba(255, 223, 186, 0.8)',
                        'rgba(255, 255, 186, 0.8)',
                        'rgba(186, 255, 201, 0.8)',
                        'rgba(186, 225, 255, 0.8)',
                        'rgba(181, 234, 215, 0.8)',
                        'rgba(174, 198, 207, 0.8)',
                        'rgba(203, 170, 203, 0.8)',
                        'rgba(224, 187, 228, 0.8)',
                        'rgba(255, 204, 229, 0.8)',
                        'rgba(215, 192, 174, 0.8)',
                        'rgba(214, 214, 214, 0.8)',
                        'rgba(169, 169, 169, 0.8)',
                        'rgba(226, 240, 203, 0.8)',
                        'rgba(255, 218, 193, 0.8)',
                        'rgba(213, 198, 224, 0.8)',
                        'rgba(204, 230, 224, 0.8)',
                        'rgba(179, 148, 196, 0.8)',
                    ],
                    borderWidth: 1,
                  },
                ],
            };
            setOptionPieData(optionPie);
        }
    };

    const backToSelectCategory = () => {
        navigate('../category');
    }

    return (
        <div className='main'>
            <div className='header-div'>
            <img src='./img/header-removebg-preview.png'></img>
            </div>
            {isFetch
            && <div style={{display: 'flex'}}>
                <div className='loader'></div>
                <p>取得中</p>
                </div>
            }
            {!isFetch
            &&
            <div className='body-div'>
                <div className='back-button'><p onClick={() => backToSelectCategory()}>カテゴリ選択へ戻る</p></div>
                {votedCategory
                && <p style={{"margin": "10px 15px"}}>あなたは {votedCategory} カテゴリの {votedOption} を選択しました</p>
                }
                {!votedCategory
                && <p style={{"margin": "10px 15px"}}>あなたは未投票です</p>
                }
                <Pie ref={chartRef} data={categoryPieData} options={chartOptions} onClick={selectCategory} />
                <BottomSheet open={open} onDismiss={() => setOpen(false)}>
                    <Pie data={optionPieData} options={chartOptions} width={'80%'} />
                </BottomSheet>
            </div>
            }
        </div>
    );
}

export default Results;